module.exports = "<div *ngIf=\"!userHasBeenActivated\">\n  <p>\n    Completing the user registration, sending the code: {{code}} to the server.\n  </p>\n</div>\n\n<div *ngIf=\"userHasBeenActivated\">\n    <p>\n      User activation success!.\n    </p>\n</div>\n\n<a routerLink=\"/\" routerLinkActive=\"active\">Go to the home page</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/template/register/registration-confirmed/registration-confirmed.component.html
// module id = ./src/app/template/register/registration-confirmed/registration-confirmed.component.html
// module chunks = main